/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as AppPropTypes from '../../lib/PropTypes';
import Html from '../partials/Html';
import Image from '../partials/Image';

import styles from '../../../styles/cards/stat.module.scss';

const propTypes = {
    item: AppPropTypes.card.isRequired,
    size: PropTypes.oneOf(['small', 'large']),
    theme: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    size: 'large',
    theme: null,
    className: null,
};

const StatCard = ({ size, item, theme, className }) => {
    const { description = null, stat = null, small = null, image = null, alt } = item || {};

    const finalSize = small ? 'small' : size;

    return (
        <div
            className={classNames([
                styles.container,
                styles[finalSize],
                styles[theme],
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                <div className={styles.top}>
                    {image !== null ? (
                        <div className={styles.imageContainer}>
                            <Image size="small" className={styles.image} media={image} alt={alt} />
                        </div>
                    ) : null}
                    {stat !== null ? (
                        <div
                            className={classNames([
                                styles.stat,
                                {
                                    [styles.long]: stat.length > 5,
                                },
                            ])}
                        >
                            <Html body={stat} tag="p" />
                        </div>
                    ) : null}
                    {finalSize === 'small' ? (
                        <div className={styles.description}>
                            <Html body={description} />
                        </div>
                    ) : null}
                </div>
                {finalSize === 'large' ? (
                    <div className={styles.bottom}>
                        <div className={styles.description}>
                            <Html body={description} />
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

StatCard.propTypes = propTypes;
StatCard.defaultProps = defaultProps;

export default StatCard;
